<template lang="html">

  <div class="section-header">
    <slot></slot>
    <div class="flex items-center">
      <p class="is-bold is-left-aligned"><strong>{{title}}</strong></p>
      <Tooltip
        v-if="tooltip"
        :tooltipText="tooltip"/>
    </div>
  </div>

</template>

<script lang="js">
import Tooltip from '@/components/Tooltip.vue';

export default {
  name: 'HeaderSection',
  components: {
    Tooltip,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
    },
  },
  mounted() {

  },
  data() {
    return {

    };
  },
  methods: {

  },
  computed: {

  },
};
</script>

<style scoped lang="scss">
</style>
